<template>
  <div class="tabs-container">
    <DxTabs :data-source="tabs" class="tabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
      :item-template="tabTemplate" />
    <div v-if="selectedIndex === 0" class="tab-conent">
      <Users />
    </div>
    <div v-if="selectedIndex === 1" class="tab-content">
      <v-row>
        <v-col cols="6">
          <GridRoluri @selection-changed="handleSelectionChanged" />
        </v-col>
        <v-col cols="6">
          <GridRoluriUtilizatori :RolID="selectedRow" />
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script lang="ts">
import { DxTabs } from 'devextreme-vue/tabs';
import Users from './Users.vue'
import GridRoluri from '../AUTH/GridRoluri.vue';
import GridRoluriUtilizatori from '../AUTH/GridRoluriUtilizatori.vue';
export default {
  components: {
    DxTabs,
    Users,
    GridRoluri,
    GridRoluriUtilizatori
  },
  data() {
    return {
      tabs: [
        { text: 'Utilizatori' },
        { text: 'Roluri' },
      ],
      selectedIndex: 0,
      selectedRow: null as any
    };
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div>${itemData.text}</div>`;
    },
    handleSelectionChanged(selectedRow: any) {
      this.selectedRow = selectedRow.ID;


    },
  },
};
</script>

<style></style>